import React, {Component} from 'react';
import {Chip, Grid, IconButton, Slider} from "@mui/material";

import Loading from "../loading/Loading";
import Modal from "../../../src/component/modal/ModalTemplate";
import PaginationComponent from "../table/Pagination";
import button from "bootstrap/js/src/button";
import TextInput from "../input/TextInput";
import SingleButton from "../button/SingleButton";
import AppRequestModal from "./AppRequestModal";

import * as apiUtil from "../../util/apiUtil";
import * as arrayUtil from "../../util/arrayUtil";

import './MessageMosuSelectModal.css';
import PhoneRegisterModal from "../../pages/mypage/modal/PhoneRegisterModal";
import * as stringUtil from "../../util/stringUtil";
import {containsJsonElement} from "../../util/arrayUtil";

const chipButtonStyle = {
    bgcolor: "#FFFFFF",
    border: "1px solid #5D87FF",
    color: "inherit",
    "& .MuiChip-deleteIcon": {
        color: "#5D87FF",
    },
    "& .MuiChip-deleteIcon:hover": {
        color: "#3C6DFF",
    },
};

const button1Style = {
    bgcolor: "#E0F2FE",
    height: 18,
    borderRadius: 9,
    fontSize: "0.6rem",
    '&:hover': {
        bgcolor: "#BAE6FD",
    },
    color: "inherit"
}

const button2Style = {
    bgcolor: "#FEF3C7",
    height: 18,
    borderRadius: 9,
    fontSize: "0.6rem",
    '&:hover': {
        bgcolor: "#FDE68A",
    },
    color: "inherit"
}
class MessageMosuSelectModal extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.selectTargetingCategory = this.selectTargetingCategory.bind(this);

        this.setValue = this.setValue.bind(this);
        this.handleChangeAge = this.handleChangeAge.bind(this);
        this.handleChangeSex = this.handleChangeSex.bind(this);
        this.handleWebappListPageChange = this.handleWebappListPageChange.bind(this);
        this.handleChangeWebAppSearch = this.handleChangeWebAppSearch.bind(this);
        this.searchWebAppAction = this.searchWebAppAction.bind(this);
        this.handleCheckWebapp = this.handleCheckWebapp.bind(this);
        this.handleCheckDynamicProfile = this.handleCheckDynamicProfile.bind(this);
        this.handleDynamicProfileListPageChange = this.handleDynamicProfileListPageChange.bind(this);
        this.handleChangeDynamicProfileSearch = this.handleChangeDynamicProfileSearch.bind(this);
        this.searchDynamicProfileAction = this.searchDynamicProfileAction.bind(this);
        this.handleChangePoiCat1 = this.handleChangePoiCat1.bind(this);
        this.handleChangePoiCat2 = this.handleChangePoiCat2.bind(this);
        this.handleChangePoiCat3 = this.handleChangePoiCat3.bind(this);
        this.handleChangePoiCat4 = this.handleChangePoiCat4.bind(this);
        this.handleChangePoiItem = this.handleChangePoiItem.bind(this);
        this.handleChangeTelMainValue = this.handleChangeTelMainValue.bind(this);
        this.handleChangeTelMidValue = this.handleChangeTelMidValue.bind(this);
        this.handleChangeTelSubValue = this.handleChangeTelSubValue.bind(this);
        this.handleChangeHomeMainValue = this.handleChangeHomeMainValue.bind(this);
        this.handleChangeHomeMidValue = this.handleChangeHomeMidValue.bind(this);
        this.handleChangeHomeSubValue = this.handleChangeHomeSubValue.bind(this);
        this.handleChangeWorkMainValue = this.handleChangeWorkMainValue.bind(this);
        this.handleChangeWorkMidValue = this.handleChangeWorkMidValue.bind(this);
        this.handleChangeWorkSubValue = this.handleChangeWorkSubValue.bind(this);
        this.handleChangePro = this.handleChangePro.bind(this);
        this.handlePhoneListPageChange = this.handlePhoneListPageChange.bind(this);
        this.handleChangePhoneSearch = this.handleChangePhoneSearch.bind(this);
        this.searchPhoneNameAction = this.searchPhoneNameAction.bind(this);
        this.handleCheckPhoneNumber = this.handleCheckPhoneNumber.bind(this);
        this.handleCheckHomeMidAll = this.handleCheckHomeMidAll.bind(this);
        this.handleCheckHomeSubAll = this.handleCheckHomeSubAll.bind(this);
        this.handleCheckWorkMidAll = this.handleCheckWorkMidAll.bind(this);
        this.handleCheckWorkSubAll = this.handleCheckWorkSubAll.bind(this);

        this.ajaxGetWebAppList = this.ajaxGetWebAppList.bind(this);
        this.ajaxGetDynamicProfileList = this.ajaxGetDynamicProfileList.bind(this);
        this.ajaxGetPoiCategory = this.ajaxGetPoiCategory.bind(this);
        this.ajaxGetTelMain = this.ajaxGetTelMain.bind(this);
        this.ajaxGetTelMid = this.ajaxGetTelMid.bind(this);
        this.ajaxGetTelSub = this.ajaxGetTelSub.bind(this);
        this.ajaxGetHomeMain = this.ajaxGetHomeMain.bind(this);
        this.ajaxGetHomeMid = this.ajaxGetHomeMid.bind(this);
        this.ajaxGetHomeSub = this.ajaxGetHomeSub.bind(this);
        this.ajaxGetWorkMain = this.ajaxGetWorkMain.bind(this);
        this.ajaxGetWorkMid = this.ajaxGetWorkMid.bind(this);
        this.ajaxGetWorkSub = this.ajaxGetWorkSub.bind(this);
        this.ajaxGetPhoneList = this.ajaxGetPhoneList.bind(this);

        this.resetValue = this.resetValue.bind(this);
        this.resetTargeting = this.resetTargeting.bind(this);
        this.ajaxGetMosu = this.ajaxGetMosu.bind(this);

        this.addSelectTel = this.addSelectTel.bind(this);
        this.addSelectHomeLoc = this.addSelectHomeLoc.bind(this);
        this.addSelectWorkLoc = this.addSelectWorkLoc.bind(this);
        this.addSelectPoi = this.addSelectPoi.bind(this);
        this.addSelectAge = this.addSelectAge.bind(this);

        this.deleteSelectedValue = this.deleteSelectedValue.bind(this);
        this.moveToAnd = this.moveToAnd.bind(this);
        this.moveToOr = this.moveToOr.bind(this);
        this.deleteAndSelectedValue = this.deleteAndSelectedValue.bind(this);
        this.deleteOrSelectedValue = this.deleteOrSelectedValue.bind(this);
        this.moveFromAndToOr = this.moveFromAndToOr.bind(this);
        this.moveFromOrToAnd = this.moveFromOrToAnd.bind(this);

        this.handleWebappRequestModal = this.handleWebappRequestModal.bind(this);
        this.handlePhoneRegisterModal = this.handlePhoneRegisterModal.bind(this);

        this.setPhoneRegisterInfo = this.setPhoneRegisterInfo.bind(this);
        this.ajaxRegisterPhoneNumber = this.ajaxRegisterPhoneNumber.bind(this);

        this.handleDragStart = this.handleDragStart.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.allowDrop = this.allowDrop.bind(this);

        this.state = {
            loading: false,

            targetingCategory: "AGE",

            atsSelectList: [],      // data 구조 : { type: "", label: "", value: "" }
            atsAndList: [],
            atsOrList: [],

            ageFrom: 20,
            ageTo: 99,
            sex: '',

            webappSearch: '',
            webappSearchResult: true,
            webappListPage: 1,
            webappListSize: 10,
            webappListTotal: 0,
            webappList: [],
            dynamicProfileList: [],
            dynamicProfileSearch: '',
            dynamicProfileListPage: 1,
            dynamicProfileListSize: 10,
            dynamicProfileListTotal: 0,

            poiCat1List: [],
            poiCat2List: [],
            poiCat3List: [],
            poiCat4List: [],
            poiItemList: [],
            poiCat1Value: "",
            poiCat2Value: "",
            poiCat3Value: "",
            poiCat4Value: "",
            poiItemValue: "",
            poiCat1Label: "",
            poiCat2Label: "",
            poiCat3Label: "",
            poiCat4Label: "",
            poiItemLabel: "",

            telMain: [],
            telMid: [],
            telSub: [],
            telMainValue: 0,
            telMidValue: 0,
            telSubValue: 0,
            telMainLabel: "",
            telMidLabel: "",
            telSubLabel: "",

            homeMain: [],
            homeMid: [],
            homeSub: [],
            homeMainValue: "",
            homeMidValue: "",
            homeSubValue: "",
            homeMainLabel: "",
            homeMidLabel: "",
            homeSubLabel: "",
            homeMidCheckAll: false,
            homeSubCheckAll: false,

            workMain: [],
            workMid: [],
            workSub: [],
            workMainValue: "",
            workMidValue: "",
            workSubValue: "",
            workMainLabel: "",
            workMidLabel: "",
            workSubLabel: "",
            workMidCheckAll: false,
            workSubCheckAll: false,

            selectedProMain: null, // 상위 카테고리
            pro: "", // 현재 선택된 하위 코드

            phoneSearch: '',
            phoneListPage: 1,
            phoneListSize: 10,
            phoneListTotal: 0,
            phoneList: [],

            appRequestModal: false,
            phoneRegisterModal: false,

            phoneRegisterName: "",
            phoneRegisterList: ["","","","","","","","","",""],

            targetLabel: "",
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    async selectTargetingCategory(category) {
        await this.setState({ targetingCategory: category });

        switch (category) {
            case "TEL":
                this.ajaxGetTelMain();
                break;
            case "DYNAMIC_PROFILE":
                this.ajaxGetDynamicProfileList();
                break;
            case "POI":
                this.ajaxGetPoiCategory({});
                break;
            case "HOMELOC":
                this.ajaxGetHomeMain();
                break;
            case "WORKLOC":
                this.ajaxGetWorkMain();
                break;
            case "PRO":
                break;
            case "CALL":
                this.ajaxGetPhoneList();
                break;
            default:
                break;
        }
    }

    setValue(id, value) {
        switch (id) {
            case "ageFrom":
                this.setState((prevState) => {
                    const ageFrom = Math.min(Math.max(value === '-' ? 0 : value, 0), 99);

                    return {
                        ageFrom: ageFrom,
                        atsSelectList: prevState.atsSelectList.map((item) =>
                            item.type === "AGE"
                                ? {
                                    ...item,
                                    label: `연령 : ${ageFrom}세 ~ ${prevState.ageTo}세`,
                                    value: [ageFrom, prevState.ageTo],
                                }
                                : item
                        )
                    };
                });
                break;
            case "ageTo":
                this.setState((prevState) => {
                    const ageTo = Math.min(Math.max(value === '-' ? 0 : value, 0), 99);
                    return {
                        ageTo: ageTo,
                        atsSelectList: prevState.atsSelectList.map((item) =>
                            item.type === "AGE"
                                ? {
                                    ...item,
                                    label: `연령 : ${prevState.ageFrom}세 ~ ${ageTo}세`,
                                    value: [prevState.ageFrom, ageTo],
                                }
                                : item
                        )
                    }
                });
                break;
            default:
                break;
        }
    }

    handleChangeAge(event, value) {
        this.setState((prevState) => ({
            ageFrom: Math.min(value[0], value[1]), ageTo: Math.max(value[1], value[0]),
            atsSelectList: prevState.atsSelectList.map((item) =>
                item.type === "AGE"
                    ? {
                        ...item,
                        label: `연령 : ${value[0]}세 ~ ${value[1]}세`,
                        value: [value[0], value[1]],
                    }
                : item
            )
        }));
    }

    handleChangeSex(value) {
        const { atsSelectList } = this.state;

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "SEX", "value", value)) {
            this.setState((prevState) => ({
                sex: value,
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "SEX", label: `성별 : ${value === 0 ? "전체" : (value === 1 ? "남성" : "여성")}`, value: value }
                ],
            }));
        }
    }

    ajaxGetWebAppList() {
        const { webappListPage, webappListSize, webappSearch } = this.state;

        apiUtil.asyncRequest({
            url: `/api/category/ats/webapp/list`,
            method: apiUtil.requestMethod.POST,
            data: {
                search: webappSearch,
                page: webappListPage,
                size: webappListSize,
            },
            success: (result) => {
                this.setState({
                    webappListTotal: result.total,
                    webappList: result.content,
                    webappSearchResult: result.total > 0,
                });
            }
        });
    }

    async handleWebappListPageChange(event, value) {
        await this.setState({
            webappListPage: value
        });
        this.ajaxGetWebAppList();
    }

    handleChangeWebAppSearch(id, value) {
        this.setState({
            webappSearch: value
        });
    }

    async searchWebAppAction() {
        await this.setState({
            webappListPage: 1,
        });
        this.ajaxGetWebAppList();
    }

    handleCheckWebapp(item) {
        const { atsSelectList } = this.state;

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "APP", "value", item.value)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "APP", label: `사용 앱/웹 : ${item.name}`, value: item.value }
                ],
            }));
        }
    }

    ajaxGetDynamicProfileList() {
        const { dynamicProfileSearch, dynamicProfileListPage, dynamicProfileListSize } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/dynamic/profile/list",
            method: apiUtil.requestMethod.POST,
            data: {
                search: dynamicProfileSearch,
                page: dynamicProfileListPage,
                size: dynamicProfileListSize,
            },
            success: (result) => {
                this.setState({
                    dynamicProfileListTotal: result.total,
                    dynamicProfileList: result.content || [],
                });
            }
        });
    }

    async handleDynamicProfileListPageChange(event, value) {
        await this.setState({
            dynamicProfileListPage: value
        });
        this.ajaxGetDynamicProfileList();
    }

    handleChangeDynamicProfileSearch(id, value) {
        this.setState({
            dynamicProfileSearch: value
        });
    }

    async searchDynamicProfileAction() {
        await this.setState({
            dynamicProfileListPage: 1,
        });
        this.ajaxGetDynamicProfileList();
    }

    handleCheckDynamicProfile(item) {
        const { atsSelectList } = this.state;
        const label = `고객 성향 : ${item.profileName}`;

        if (!arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "DYNAMIC_PROFILE", "label", label)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "DYNAMIC_PROFILE", label, value: [item.profileId] }
                ],
            }));
        }
    }

    ajaxGetPoiCategory(data) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/poi/category",
            method: apiUtil.requestMethod.POST,
            data: data,
            success: (result) => {
                if (data.cat4) {
                    this.setState({
                        poiItemList: result || [],
                    });
                    return;
                }

                if (data.cat3) {
                    this.setState({
                        poiCat4List: result || [],
                        poiItemList: [],
                    });
                    return;
                }

                if (data.cat2) {
                    this.setState({
                        poiCat3List: result || [],
                        poiCat4List: [],
                        poiItemList: [],
                    });
                    return;
                }

                if (data.cat1) {
                    this.setState({
                        poiCat2List: result || [],
                        poiCat3List: [],
                        poiCat4List: [],
                        poiItemList: [],
                    });
                    return;
                }

                this.setState({
                    poiCat1List: result || [],
                    poiCat2List: [],
                    poiCat3List: [],
                    poiCat4List: [],
                    poiItemList: [],
                });
            }
        });
    }

    handleChangePoiCat1(item) {
        this.setState({
            poiCat1Value: item.value,
            poiCat1Label: item.name,
            poiCat2Value: "",
            poiCat2Label: "",
            poiCat3Value: "",
            poiCat3Label: "",
            poiCat4Value: "",
            poiCat4Label: "",
            poiItemValue: "",
            poiItemLabel: "",
            poiCat2List: [],
            poiCat3List: [],
            poiCat4List: [],
            poiItemList: [],
        });
        this.ajaxGetPoiCategory({ cat1: item.value });
    }

    handleChangePoiCat2(item) {
        const { poiCat1Value } = this.state;

        this.setState({
            poiCat2Value: item.value,
            poiCat2Label: item.name,
            poiCat3Value: "",
            poiCat3Label: "",
            poiCat4Value: "",
            poiCat4Label: "",
            poiItemValue: "",
            poiItemLabel: "",
            poiCat3List: [],
            poiCat4List: [],
            poiItemList: [],
        });
        this.ajaxGetPoiCategory({
            cat1: poiCat1Value,
            cat2: item.value,
        });
    }

    handleChangePoiCat3(item) {
        const { poiCat1Value, poiCat2Value } = this.state;

        this.setState({
            poiCat3Value: item.value,
            poiCat3Label: item.name,
            poiCat4Value: "",
            poiCat4Label: "",
            poiItemValue: "",
            poiItemLabel: "",
            poiCat4List: [],
            poiItemList: [],
        });
        this.ajaxGetPoiCategory({
            cat1: poiCat1Value,
            cat2: poiCat2Value,
            cat3: item.value,
        });
    }

    handleChangePoiCat4(item) {
        const { poiCat1Value, poiCat2Value, poiCat3Value } = this.state;

        this.setState({
            poiCat4Value: item.value,
            poiCat4Label: item.name,
            poiItemValue: "",
            poiItemLabel: "",
            poiItemList: [],
        });
        this.ajaxGetPoiCategory({
            cat1: poiCat1Value,
            cat2: poiCat2Value,
            cat3: poiCat3Value,
            cat4: item.value,
        });
    }

    async handleChangePoiItem(item) {
        await this.setState({
            poiItemValue: item.value,
            poiItemLabel: item.name,
        });

        this.addSelectPoi();
    }

    handleChangeTelMainValue(value) {
        this.setState({
            telMainValue: value.uid,
            telMidValue: 0,
            telSubValue: 0,
            telMainLabel: value.name,
            telMidLabel: '',
            telSubLabel: '',
        });
        this.ajaxGetTelMid(value.uid);
    }

    handleChangeTelMidValue(value) {
        this.setState({
            telMidValue: value.uid,
            telSubValue: 0,
            telMidLabel: value.name,
            telSubLabel: '',
        });
        this.ajaxGetTelSub(value.uid);
    }

    async handleChangeTelSubValue(value) {
        await this.setState({
            telSubValue: value.uid,
            telSubLabel: value.name,
        });

        this.addSelectTel();
    }

    ajaxGetTelMain() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/tel",
            method: apiUtil.requestMethod.POST,
            data: {
                cateid: null
            },
            success: async (result) => {
                this.setState({
                    telMain: result,
                });
            }
        });
    }

    ajaxGetTelMid(value) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/tel",
            method: apiUtil.requestMethod.POST,
            data: {
                cateid: value
            },
            success: async (result) => {
                this.setState({
                    telMid: result,
                    telSub: [],
                });
            }
        });
    }

    ajaxGetTelSub(value) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/tel",
            method: apiUtil.requestMethod.POST,
            data: {
                cateid: value
            },
            success: async (result) => {
                this.setState({
                    telSub: result,
                });
            }
        });
    }

    handleChangeHomeMainValue(value) {
        this.setState({
            homeMainValue: value.uid,
            homeMainLabel: value.name,
            homeMidValue: "",
            homeMidLabel: "",
            homeSubValue: "",
            homeSubLabel: "",
            homeMidCheckAll: false,
            homeSubCheckAll: false,
        });
        this.ajaxGetHomeMid(value.uid);
    }

    handleChangeHomeMidValue(value) {
        this.setState({
            homeMidValue: value.uid,
            homeMidLabel: value.name,
            homeSubValue: "",
            homeSubLabel: "",
            homeMidCheckAll: false,
            homeSubCheckAll: false,
        });

        this.ajaxGetHomeSub(value.uid);
    }

    async handleChangeHomeSubValue(value) {
        await this.setState({
            homeSubValue: value.uid,
            homeSubLabel: value.name,
            homeMidCheckAll: false,
            homeSubCheckAll: false,
        });

        this.addSelectHomeLoc();
    }

    async handleCheckHomeMidAll() {
        await this.setState({
            homeMidCheckAll: true,
            homeMidValue: "",
            homeMidLabel: "전체",
            homeSubValue: "",
            homeSubLabel: "",
            homeSub: [],
        });

        this.addSelectHomeLoc();
    }

    async handleCheckHomeSubAll() {
        await this.setState({
            homeSubCheckAll: true,
            homeSubValue: "",
            homeSubLabel: "전체",
        });

        this.addSelectHomeLoc();
    }

    ajaxGetHomeMain() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 1,
            },
            success: async (result) => {
                this.setState({
                    homeMain: result,
                });
            }
        });
    }

    ajaxGetHomeMid(value) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 2,
                sidoCd: value,
            },
            success: async (result) => {
                this.setState({
                    homeMid: result,
                    homeSub: [],
                });
            }
        });
    }

    ajaxGetHomeSub(value) {
        const { homeMainValue } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 3,
                sidoCd: homeMainValue,
                sggCd: value,
            },
            success: async (result) => {
                this.setState({
                    homeSub: result,
                });
            }
        });
    }

    handleChangeWorkMainValue(value) {
        this.setState({
            workMainValue: value.uid,
            workMainLabel: value.name,
            workMidValue: "",
            workMidLabel: "",
            workSubValue: "",
            workSubLabel: "",
            workMidCheckAll: false,
            workSubCheckAll: false,
        });
        this.ajaxGetWorkMid(value.uid);
    }

    handleChangeWorkMidValue(value) {
        this.setState({
            workMidValue: value.uid,
            workMidLabel: value.name,
            workSubValue: "",
            workSubLabel: "",
            workMidCheckAll: false,
            workSubCheckAll: false,
        });
        this.ajaxGetWorkSub(value.uid);
    }

    async handleChangeWorkSubValue(value) {
        await this.setState({
            workSubValue: value.uid,
            workSubLabel: value.name,
            workMidCheckAll: false,
            workSubCheckAll: false,
        });

        this.addSelectWorkLoc();
    }

    async handleCheckWorkMidAll() {
        await this.setState({
            workMidCheckAll: true,
            workMidValue: "",
            workMidLabel: "전체",
            workSubValue: "",
            workSubLabel: "",
            workSub: [],
        });

        this.addSelectWorkLoc();
    }

    async handleCheckWorkSubAll() {
        await this.setState({
            workSubCheckAll: true,
            workSubValue: "",
            workSubLabel: "전체",
        });

        this.addSelectWorkLoc();
    }

    ajaxGetWorkMain() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 1,
            },
            success: async (result) => {
                this.setState({
                    workMain: result,
                });
            }
        });
    }

    ajaxGetWorkMid(value) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 2,
                sidoCd: value,
            },
            success: async (result) => {
                this.setState({
                    workMid: result,
                    workSub: [],
                });
            }
        });
    }

    ajaxGetWorkSub(value) {
        const { workMainValue } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/loc",
            method: apiUtil.requestMethod.POST,
            data: {
                level: 3,
                sidoCd: workMainValue,
                sggCd: value,
            },
            success: async (result) => {
                this.setState({
                    workSub: result,
                });
            }
        });
    }

    handleChangePro(value) {
        const { atsSelectList } = this.state;

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "PRO", "value", value)) {
            let label;
            switch (value) {
                case "SELF":
                    label = "자영업자 추정";
                    break;
                case "WORK":
                    label = "직장인 추정";
                    break;
                case "SINGLE_1":
                    label = "1인가구 추정(청년 1인 가구)";
                    break;
                case "SINGLE_2":
                    label = "1인가구 추정(실버 1인 가구)";
                    break;
                case "PARENT_1":
                    label = "부모 추정(초등학생 저학년 부모)";
                    break;
                case "PARENT_2":
                    label = "부모 추정(초등학생 고학년 부모)";
                    break;
                case "PARENT_3":
                    label = "부모 추정(중학생 부모)";
                    break;
                case "PARENT_4":
                    label = "부모 추정(고등학생 부모)";
                    break;
                case "PARENT_5":
                    label = "부모 추정(대학생 부모)";
                    break;
                case "MOVEMENT_1":
                    label = "이사/출국 확률(이사 확률)";
                    break;
                case "MOVEMENT_2":
                    label = "이사/출국 확률(출국 확률)";
                    break;
                case "LEISURE_1":
                    label = "레저 관련 방문(골프)";
                    break;
                case "LEISURE_2":
                    label = "레저 관련 방문(캠핑)";
                    break;
                case "LEISURE_3":
                    label = "레저 관련 방문(등산)";
                    break;
                case "LEISURE_4":
                    label = "레저 관련 방문(스키장)";
                    break;
                case "LEISURE_5":
                    label = "레저 관련 방문(워터파크/놀이공원)";
                    break;
            }

            this.setState((prevState) => ({
                pro: value,
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "PRO", label: `예측 모델 : ${label}`, value: value }
                ],
            }));
        }
    }

    ajaxGetPhoneList() {
        const { phoneListPage, phoneListSize, phoneSearch } = this.state;

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/list`,
            method: apiUtil.requestMethod.POST,
            data: {
                search: phoneSearch,
                page: phoneListPage,
                size: phoneListSize,
            },
            success: (result) => {
                this.setState({
                    phoneListTotal: result.total,
                    phoneList: result.content,
                });
            }
        });
    }

    async handlePhoneListPageChange(event, value) {
        await this.setState({
            phoneListPage: value
        });
        this.ajaxGetPhoneList();
    }

    handleChangePhoneSearch(id, value) {
        this.setState({
            phoneSearch: value
        });
    }

    async searchPhoneNameAction() {
        await this.setState({
            phoneListPage: 1,
        });
        this.ajaxGetPhoneList();
    }

    handleCheckPhoneNumber(item) {
        const { atsSelectList } = this.state;

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "CALL", "value", item.registerName)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "CALL", label: `등록 전화번호 : ${item.name}`, value: item.registerName }
                ],
            }));
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( prevProps.remindCmpnId !== this.props.remindCmpnId) {
            const { sndMosuJson } = this.props;

            if(! sndMosuJson) return;

            apiUtil.asyncRequest({
                url: `/api/category/ats/info`,
                method: apiUtil.requestMethod.POST,
                data: {
                    sndMosuJson: sndMosuJson
                },
                success: (result) => {
                    this.setState({
                        atsAndList: result.atsAndList || [],
                        atsOrList: result.atsOrList || []
                    }, () => {
                        // 라벨 설정
                        this.setTargetLabel();

                        this.setState({}, () => { // 빈 setState로 콜백 사용
                            apiUtil.asyncRequest({
                                setLoading: this.setLoading,
                                url: "/api/category/ats/mosu/count?type=RESET",
                                method: apiUtil.requestMethod.POST,
                                data: {
                                    atsAndList: this.state.atsAndList,
                                    atsOrList: this.state.atsOrList,
                                },
                                success: (countResult) => {
                                    const { setMosuData, handleClose } = this.props;
                                    setMosuData(countResult);
                                }
                            });
                        });
                    });
                }
            });
            return;
        }

        if(prevProps.isRemind !== this.props.isRemind && !this.props.isRemind) {
            this.resetValue();
        }
    }

    resetValue() {
        this.setState({
            targetingCategory: "AGE",

            atsSelectList: [],      // data 구조 : { type: "", label: "", value: "" }
            atsAndList: [],
            atsOrList: [],

            ageFrom: 20,
            ageTo: 99,
            sex: '',

            webappSearch: '',
            webappSearchResult: true,
            webappListPage: 1,
            webappListSize: 10,
            webappListTotal: 0,
            webappList: [],

            poiCat1List: [],
            poiCat2List: [],
            poiCat3List: [],
            poiCat4List: [],
            poiItemList: [],
            poiCat1Value: "",
            poiCat2Value: "",
            poiCat3Value: "",
            poiCat4Value: "",
            poiItemValue: "",
            poiCat1Label: "",
            poiCat2Label: "",
            poiCat3Label: "",
            poiCat4Label: "",
            poiItemLabel: "",

            telMain: [],
            telMid: [],
            telSub: [],
            telMainValue: 0,
            telMidValue: 0,
            telSubValue: 0,
            telMainLabel: "",
            telMidLabel: "",
            telSubLabel: "",

            homeMain: [],
            homeMid: [],
            homeSub: [],
            homeMainValue: "",
            homeMidValue: "",
            homeSubValue: "",
            homeMainLabel: "",
            homeMidLabel: "",
            homeSubLabel: "",
            homeMidCheckAll: false,
            homeSubCheckAll: false,

            workMain: [],
            workMid: [],
            workSub: [],
            workMainValue: "",
            workMidValue: "",
            workSubValue: "",
            workMainLabel: "",
            workMidLabel: "",
            workSubLabel: "",
            workMidCheckAll: false,
            workSubCheckAll: false,

            pro: '',

            phoneSearch: '',
            phoneListPage: 1,
            phoneListSize: 10,
            phoneListTotal: 0,
            phoneList: [],

            targetLabel: '',
        });
    }

    resetTargeting() {
        const { resetMosuData } = this.props;
        this.resetValue();
        resetMosuData();
    }

    deleteSelectedValue(item) {
        const { atsSelectList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        switch (item.type) {
            case "AGE":
                let ageNewArray = arrayUtil.deleteJsonElement(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    atsSelectList: ageNewArray,
                });
                break;
            case "SEX":
                let sexNewArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    sex: '',
                    atsSelectList: sexNewArray,
                });
                break;
            case "APP":
                let webappArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    atsSelectList: webappArray,
                });
                break;
            case "HOMELOC":
                let homeArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type,"value", item.value);
                this.setState({
                    atsSelectList: homeArray,
                });
                break;
            case "WORKLOC":
                let workArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type,"value", item.value);
                this.setState({
                    atsSelectList: workArray,
                });
                break;
            case "TEL":
                let telArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    atsSelectList: telArray,
                });
                break;
            case "CALL":
                let phoneArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    atsSelectList: phoneArray,
                });
                break;
            case "PRO":
                let proNewArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    pro: '',
                    atsSelectList: proNewArray,
                });
                break;
            case "DYNAMIC_PROFILE":
                let dynamicProfileArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "label", item.label);
                this.setState({
                    atsSelectList: dynamicProfileArray,
                });
                break;
            case "POI":
                let poiArray = arrayUtil.deleteJsonElementMultiKey(atsSelectList, "type", item.type, "value", item.value);
                this.setState({
                    atsSelectList: poiArray,
                });
                break;
        }
    }

    moveToAnd(item) {
        const { atsAndList, atsOrList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        if(atsAndList.length >= 5) {
            alert("AND 조건은 최대 5개까지 선택 가능합니다.")
            return;
        }

        if (item.type === "AGE") {
            const { ageFrom, ageTo } = this.state;

            if(ageFrom > ageTo) {
                alert("최소 나이는 최대 나이 이하로 설정해야 합니다.");
                return;
            } else if (ageFrom < 19) {
                alert("최소 나이는 19세 이상으로 설정해야 합니다.");
                return;
            }

            if(arrayUtil.containsJsonElement(atsOrList, "type", "AGE")) {
                alert("and 조건 또는 or 조건 한곳에만 나이 필터를 추가할 수 있습니다.");
                return;
            }

            if (arrayUtil.containsJsonElement(atsAndList, "type", item.type)) {
                alert("and 조건에는 연령 필터는 하나만 입력할 수 있습니다.");
                return;
            }
        } else if (item.type === "SEX") {
            if(arrayUtil.containsJsonElement(atsOrList, "type", item.type)) {
                alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
                return;
            }

            // if (arrayUtil.containsJsonElement(atsAndList, "type", item.type)) {
            //     alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
            //     return;
            // }
        } else {
            if (arrayUtil.containsJsonElementMultiKey(atsAndList, "type", item.type, "value", item.value)) {
                return;
            }
        }

        this.deleteSelectedValue(item);

        this.setState((prevState) => ({
            atsAndList: [...prevState.atsAndList, item],
        }), () => {
            this.setTargetLabel();
        });
    }

    moveToOr(item) {
        const { atsOrList, atsAndList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        if(atsOrList.length >= 10) {
            alert("OR 조건은 최대 10개까지 선택 가능합니다.")
            return;
        }

        if (item.type === "AGE") {
            const { ageFrom, ageTo } = this.state;

            if(ageFrom > ageTo) {
                alert("최소 나이는 최대 나이 이하로 설정해야 합니다.");
                return;
            } else if (ageFrom < 19) {
                alert("최소 나이는 19세 이상으로 설정해야 합니다.");
                return;
            }

            if(arrayUtil.containsJsonElement(atsAndList, "type", item.type)) {
                alert("and 조건 또는 or 조건 한곳에만 나이 필터를 추가할 수 있습니다.");
                return;
            }

            // if (arrayUtil.containsJsonElement(atsOrList, "type", item.type)) {
            //     // 새로운 value 로 덮어쓰기
            //     return;
            // }
        } else if (item.type === "SEX") {
            // if(arrayUtil.containsJsonElement(atsOrList, "type", item.type)) {
            //     alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
            //     return;
            // }

            if (arrayUtil.containsJsonElement(atsAndList, "type", item.type)) {
                alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
                return;
            }
        } else {
            if (arrayUtil.containsJsonElementMultiKey(atsOrList, "type", item.type, "value", item.value)) {
                return;
            }
        }

        this.deleteSelectedValue(item);

        this.setState((prevState) => ({
            atsOrList: [...prevState.atsOrList, item],
        }), () => {
            this.setTargetLabel();
        });
    }

    deleteAndSelectedValue(item) {
        const { atsAndList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        switch (item.type) {
            case "AGE":
                let ageNewArray = arrayUtil.deleteJsonElement(atsAndList, "type", item.type, "value", item.value);
                this.setState({
                    atsAndList: ageNewArray,
                });
                break;
            default:
                let newArray = arrayUtil.deleteJsonElementMultiKey(atsAndList, "type", item.type, "value", item.value);
                this.setState({
                    atsAndList: newArray,
                });
                break;
        }

        this.setTargetLabel();
    }

    deleteOrSelectedValue(item) {
        const { atsOrList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        switch (item.type) {
            case "AGE":
                let ageNewArray = arrayUtil.deleteJsonElement(atsOrList, "type", item.type, "value", item.value);
                this.setState({
                    atsOrList: ageNewArray,
                });
                break;
            default:
                let newArray = arrayUtil.deleteJsonElementMultiKey(atsOrList, "type", item.type, "value", item.value);
                this.setState({
                    atsOrList: newArray,
                });
                break;
        }

        this.setTargetLabel();
    }

    moveFromAndToOr(item) {
        const { atsOrList, atsAndList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        if(atsOrList.length >= 10) {
            alert("OR 조건은 최대 10개까지 선택 가능합니다.")
            return;
        }

        if (atsAndList.filter(item => item.type === "SEX").length >= 2) {
            alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
            return;
        }

        this.deleteAndSelectedValue(item);

        if (item.type === "AGE") {
            if (arrayUtil.containsJsonElement(atsOrList, "type", item.type)) {
                this.deleteOrSelectedValue(item);
            }
        } else {
            if (arrayUtil.containsJsonElementMultiKey(atsOrList, "type", item.type, "value", item.value)) {
                return;
            }
        }

        this.setState((prevState) => ({
            atsOrList: [...prevState.atsOrList, item],
        }), () => {
            this.setTargetLabel();
        });
    }

    moveFromOrToAnd(item) {
        const { atsAndList, atsOrList } = this.state;
        const { isRemind } = this.props;

        if(isRemind) return;

        if( atsAndList.length >= 5) {
            alert("AND 조건은 최대 5개까지 선택 가능합니다.");
            return;
        }

        if(atsOrList.filter(item => item.type === "AGE").length >= 2) {
            alert("and 조건 또는 or 조건 한곳에만 나이 필터를 추가할 수 있습니다.");
            return;
        } else if (atsOrList.filter(item => item.type === "SEX").length >= 2) {
            alert("and 조건 또는 or 조건 한곳에만 성별 필터를 추가할 수 있습니다.");
            return;
        }

        this.deleteOrSelectedValue(item);

        if (item.type === "AGE") {
            if (arrayUtil.containsJsonElement(atsAndList, "type", item.type)) {
                this.deleteAndSelectedValue(item);
            }
        } else {
            if (arrayUtil.containsJsonElementMultiKey(atsAndList, "type", item.type, "value", item.value)) {
                return;
            }
        }

        this.setState((prevState) => ({
            atsAndList: [...prevState.atsAndList, item],
        }), () => {
            this.setTargetLabel();
        });

    }

    setTargetLabel() {
        const { atsAndList, atsOrList } = this.state;

        let elements = [];

        if (atsAndList.length >= 1) {
            elements.push(`( ${atsAndList[0].label}`);

            for (let i = 1; i < atsAndList.length; i++) {
                elements.push(
                    <span key={`and-${i}`} style={{ color: "red" }}> 이면서 </span>
                );
                elements.push(atsAndList[i].label);
            }
            elements.push(' )');
        }

        if (atsOrList.length >= 1) {
            if (atsAndList.length >= 1) {
                elements.push(' 중 ');
            }

            elements.push(atsOrList[0].label);

            for (let i = 1; i < atsOrList.length; i++) {
                elements.push(
                    <span key={`or-${i}`} style={{ color: "red" }}> 이거나 </span>
                );
                elements.push(atsOrList[i].label);
            }
        }

        this.setState({
            targetLabel: elements
        });
    }


    ajaxGetMosu() {
        const { atsAndList, atsOrList } = this.state;
        const { isRemind, handleClose } = this.props;

        if(isRemind) {
            handleClose();
            return;
        }

        if(atsAndList.length === 0 && atsOrList.length === 0) {
            alert('and 또는 or 조건을 최소 1개 이상 선택해주세요.');
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/mosu/count?type=RESET",
            method: apiUtil.requestMethod.POST,
            data: {
                atsAndList: atsAndList,
                atsOrList: atsOrList,
            },
            success: (result) => {
                const { setMosuData, handleClose } = this.props;
                setMosuData(result);
                handleClose();
            }
        });
    }

    addSelectTel() {
        const { atsSelectList } = this.state;
        const { telMainValue, telMainLabel, telMidValue, telMidLabel, telSubValue, telSubLabel } = this.state;

        if (! telMainValue) {
            return;
        }

        let selectValue = arrayUtil.concatToStr([telMainLabel, telMidLabel, telSubLabel], "|")
        let selectLabel = arrayUtil.concatToStr([telMainLabel, telMidLabel, telSubLabel], " > ");

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "TEL", "value", selectValue)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "TEL", label: `통화 이력 : ${selectLabel}`, value: selectValue }
                ],
            }));
        }
    }

    addSelectHomeLoc() {
        const { atsSelectList } = this.state;
        const { homeMainValue, homeMainLabel, homeMidValue, homeMidLabel, homeSubValue, homeSubLabel } = this.state;

        if (! homeMainValue) {
            return;
        }

        let selectValue = arrayUtil.concatToStr([homeMainValue, homeMidValue, homeSubValue], "")
        let selectLabel = arrayUtil.concatToStr([homeMainLabel, homeMidLabel, homeSubLabel], " > ");

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "HOMELOC", "value", selectValue)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "HOMELOC", label: `추정 거주지 : ${selectLabel}`, value: selectValue }
                ],
            }));
        }
    }

    addSelectAge() {
        const { atsSelectList } = this.state;
        const { ageFrom, ageTo } = this.state;

        if (! arrayUtil.containsJsonElement(atsSelectList, "type", "AGE", "value", [ageFrom, ageTo])) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "AGE", label: '연령 : ' + ageFrom + '세 ~ ' + ageTo + '세', value: [ageFrom, ageTo] }
                ],
            }));
        }
    }

    addSelectWorkLoc() {
        const { atsSelectList } = this.state;
        const { workMainValue, workMainLabel, workMidValue, workMidLabel, workSubValue, workSubLabel } = this.state;

        if (! workMainValue) {
            return;
        }

        let selectValue = arrayUtil.concatToStr([workMainValue, workMidValue, workSubValue], "")
        let selectLabel = arrayUtil.concatToStr([workMainLabel, workMidLabel, workSubLabel], " > ");

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "WORKLOC", "value", selectValue)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "WORKLOC", label: `추정 직장주소 : ${selectLabel}`, value: selectValue }
                ],
            }));
        }
    }

    addSelectPoi() {
        const { atsSelectList, poiItemValue, poiCat1Label, poiCat2Label, poiCat3Label, poiCat4Label, poiItemLabel } = this.state;

        if (! poiItemValue) {
            return;
        }

        let selectLabel = arrayUtil.concatToStr([poiCat1Label, poiCat2Label, poiCat3Label, poiCat4Label, poiItemLabel], " > ");

        if (! arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "POI", "value", poiItemValue)) {
            this.setState((prevState) => ({
                atsSelectList: [
                    ...prevState.atsSelectList,
                    { type: "POI", label: `오프라인 방문 이력 : ${selectLabel}`, value: poiItemValue }
                ],
            }));
        }
    }

    handleWebappRequestModal() {
        const { appRequestModal }  = this.state;
        this.setState({ appRequestModal: ! appRequestModal });
    }

    handlePhoneRegisterModal(modalName, value) {
        this.setState({ [modalName]: value });
    }

    /* 여기서 부터는 phoneRegisterModal 관련 함수 */
    setPhoneRegisterInfo(id, value) {
        const { phoneRegisterList } = this.state;

        switch(id) {
            case "phoneName":
                const name = stringUtil.removeSpecialLetter(value);
                this.setState({ phoneRegisterName: name });
                break;
            case "phoneNumber0":
            case "phoneNumber1":
            case "phoneNumber2":
            case "phoneNumber3":
            case "phoneNumber4":
            case "phoneNumber5":
            case "phoneNumber6":
            case "phoneNumber7":
            case "phoneNumber8":
            case "phoneNumber9":
                const index = id.substr(-1, 1);
                const phone = stringUtil.pureNumber(value);
                phoneRegisterList[index] = phone;
                this.setState({ phoneRegisterList: phoneRegisterList });
                break;
        }
    }

    ajaxRegisterPhoneNumber() {
        if (! window.confirm("전화번호를 등록하시겠습니까?")) return;

        const { phoneRegisterName, phoneRegisterList } = this.state;

        let list = phoneRegisterList.filter(item => item);

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/phone/create`,
            method: apiUtil.requestMethod.POST,
            data: {
                name: phoneRegisterName,
                list: list,
            },
            success: (result) => {
                alert("전화번호가 등록되었습니다.");
                this.handlePhoneRegisterModal('phoneRegisterModal', false);
                this.searchPhoneNameAction();
            }
        });
    }

    handleDragStart = (e, item, from) => {
        e.dataTransfer.setData(
            "application/json",
            JSON.stringify({ ...item, from })
        );
    };

    /** 드롭 허용 */
    allowDrop = (e) => {
        e.preventDefault();
    };

    /** 드롭 처리 */
    handleDrop = (e, target) => {
        e.preventDefault();
        const data = e.dataTransfer.getData("application/json");
        if (!data) return;

        const item = JSON.parse(data);

        const { moveToAnd, moveToOr, moveFromAndToOr, moveFromOrToAnd } = this;

        if (item.from === "SELECT" && target === "AND" && moveToAnd) {
            moveToAnd(item);
        }
        else if (item.from === "SELECT" && target === "OR" && moveToOr) {
            moveToOr(item);
        }
        else if (item.from === "AND" && target === "OR" && moveFromAndToOr) {
            moveFromAndToOr(item);
        }
        else if (item.from === "OR" && target === "AND" && moveFromOrToAnd) {
            moveFromOrToAnd(item);
        }
    };

    render() {
        const { loading } = this.state;
        const { isOpen, handleClose } = this.props;

        const { targetingCategory } = this.state;
        const { selectTargetingCategory } = this;

        const {
            ageFrom, ageTo, sex,
            telMainValue, telMidValue, telSubValue, telMainLabel, telMidLabel, telSubLabel,
            poiCat1Value, poiCat2Value, poiCat3Value, poiCat4Value, poiItemValue,
            homeMainValue, homeMidValue, homeSubValue, homeMainLabel, homeMidLabel, homeSubLabel,
            workMainValue, workMidValue, workSubValue, workMainLabel, workMidLabel, workSubLabel,
            pro,
            homeMidCheckAll, homeSubCheckAll, workMidCheckAll, workSubCheckAll,
        } = this.state;
        const {
            setValue,
            handleChangeAge, handleChangeSex,
            handleWebappListPageChange, handleChangeWebAppSearch, handleCheckWebapp, handleCheckDynamicProfile,
            handleDynamicProfileListPageChange, handleChangeDynamicProfileSearch,
            handleChangePoiCat1, handleChangePoiCat2, handleChangePoiCat3, handleChangePoiCat4, handleChangePoiItem,
            handleChangeTelMainValue, handleChangeTelMidValue, handleChangeTelSubValue,
            handleChangeHomeMainValue, handleChangeHomeMidValue, handleChangeHomeSubValue,
            handleChangeWorkMainValue, handleChangeWorkMidValue, handleChangeWorkSubValue,
            handleChangePro,
            handlePhoneListPageChange, handleChangePhoneSearch, handleCheckPhoneNumber,
            handleCheckHomeMidAll, handleCheckHomeSubAll, handleCheckWorkMidAll, handleCheckWorkSubAll
        } = this;
        const { ajaxGetWebAppList, searchWebAppAction, ajaxGetPhoneList, searchPhoneNameAction, ajaxGetDynamicProfileList, searchDynamicProfileAction } = this;

        const {
            webappListPage, webappListSize, webappListTotal, webappList, webappSearch, webappSearchResult,
            dynamicProfileList, dynamicProfileSearch, dynamicProfileListPage, dynamicProfileListSize, dynamicProfileListTotal,
            poiCat1List, poiCat2List, poiCat3List, poiCat4List, poiItemList,
            telMain, telMid, telSub,
            homeMain, homeMid, homeSub,
            workMain, workMid, workSub,
            phoneListPage, phoneListSize, phoneListTotal, phoneList, phoneSearch,
        } = this.state;

        const { resetTargeting, ajaxGetMosu } = this;

        const {
            deleteSelectedValue,
            moveToAnd, moveToOr,
            deleteAndSelectedValue, deleteOrSelectedValue,
            moveFromAndToOr, moveFromOrToAnd, addSelectAge
        } = this;
        const { atsSelectList, atsAndList, atsOrList } = this.state

        const { appRequestModal, phoneRegisterModal } = this.state;
        const { handleWebappRequestModal, handlePhoneRegisterModal } = this;

        const { setPhoneRegisterInfo, ajaxRegisterPhoneNumber } = this;
        const { phoneRegisterName, phoneRegisterList } = this.state;
        const { targetLabel } = this.state;
        const { isRemind } = this.props;

        const proMainList = [
            // { code: "SELF", label: "자영업자 추정" },
            { code: "WORK", label: "직장인 추정" },
            { code: "SINGLE", label: "1인가구 추정" },
            { code: "PARENT", label: "부모 추정" },
            { code: "MOVEMENT", label: "이사/출국 확률" },
            { code: "LEISURE", label: "레저 관련 방문" },
        ];

        // 하위 카테고리
        const proSubList = {
            SINGLE: [
                { code: "SINGLE_1", label: "청년 1인 가구" },
                { code: "SINGLE_2", label: "실버 1인 가구" },
            ],
            PARENT: [
                { code: "PARENT_1", label: "초등학생 저학년 부모" },
                { code: "PARENT_2", label: "초등학생 고학년 부모" },
                { code: "PARENT_3", label: "중학생 부모" },
                { code: "PARENT_4", label: "고등학생 부모" },
                { code: "PARENT_5", label: "대학생 부모" },
            ],
            MOVEMENT: [
                { code: "MOVEMENT_1", label: "이사 확률" },
                { code: "MOVEMENT_2", label: "출국 확률" },
            ],
            LEISURE: [
                { code: "LEISURE_1", label: "골프" },
                { code: "LEISURE_2", label: "캠핑" },
                { code: "LEISURE_3", label: "등산" },
                { code: "LEISURE_4", label: "스키장" },
                { code: "LEISURE_5", label: "워터파크/놀이공원" },
            ],
        };

        return (
            <>
            <Modal
                open={isOpen}
                handleClose={handleClose}
                className="react-full-modal"
                modalTitle="타겟팅 조건 선택"
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                <div id="mosuModal" className='modal-body p-0'>
                    <ul className="mb-0">
                        <li className="p-0 text-light-gray h6">- 조건 미설정 항목은 별도 구분 없이 전체 고객 대상으로 발송됩니다.</li>
                        <li className="p-0 mb-0 text-light-gray h6">- 타겟팅 설정은 대분류 당 하나씩만 가능하며, 조건이 너무 많을 경우 추출 대상이 줄어들 수 있습니다.</li>
                    </ul>
                    { ! isRemind &&
                    <div className="m-0 p-0 modal-container">
                        <div className="row m-0">
                            <div className="col-4 p-0 columnOverFlow columnLeft">
                                <div
                                    className={targetingCategory === "AGE" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("AGE")}
                                >
                                    <p className="m-0">연령</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-age"
                                        onChange={()=>selectTargetingCategory("AGE")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "AGE")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "SEX" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("SEX")}
                                >
                                    <p className="m-0">성별</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-sex"
                                        onChange={() => selectTargetingCategory("SEX")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "SEX")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "APP" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("APP")}
                                >
                                    <p className="m-0">사용 앱/웹</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-app"
                                        onChange={() => selectTargetingCategory("APP")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "APP")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "DYNAMIC_PROFILE" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("DYNAMIC_PROFILE")}
                                >
                                    <p className="m-0">고객 성향</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-dynamic-profile"
                                        onChange={() => selectTargetingCategory("DYNAMIC_PROFILE")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "DYNAMIC_PROFILE")}
                                        readOnly
                                    />
                                </div>

                                <div
                                    className={targetingCategory === "POI" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("POI")}
                                >
                                    <p className="m-0">오프라인 방문 이력</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-poi"
                                        onChange={() => selectTargetingCategory("POI")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "POI")}
                                        readOnly
                                    />
                                </div>

                                <div
                                    className={targetingCategory === "TEL" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("TEL")}
                                >
                                    <p className="m-0">통화 이력</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-tel"
                                        onChange={() => selectTargetingCategory("TEL")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "TEL")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "HOMELOC" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("HOMELOC")}
                                >
                                    <p className="m-0">추정 거주지</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-homeloc"
                                        onChange={() => selectTargetingCategory("HOMELOC")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "HOMELOC")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "WORKLOC" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("WORKLOC")}
                                >
                                    <p className="m-0">추정 직장주소</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-workloc"
                                        onChange={() => selectTargetingCategory("WORKLOC")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "WORKLOC")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "PRO" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("PRO")}
                                >
                                    <p className="m-0">예측 모델</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-pro"
                                        onChange={() => selectTargetingCategory("PRO")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "PRO")}
                                        readOnly
                                    />
                                </div>
                                <div
                                    className={targetingCategory === "CALL" ? "columnLeftItemActive" : "columnLeftItem"}
                                    onClick={() => selectTargetingCategory("CALL")}
                                >
                                    <p className="m-0">등록된 전화번호 분석</p>
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        name="select-pro"
                                        onChange={() => selectTargetingCategory("CALL")}
                                        checked={arrayUtil.containsJsonElement(atsSelectList, "type", "CALL")}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-8 p-0">
                                {
                                    targetingCategory === "AGE" &&
                                    <div className="p-5 h-100 position-relative">
                                        <Slider
                                            value={[ageFrom, ageTo]}
                                            min = {0}
                                            max = {99}
                                            valueLabelDisplay="auto"
                                            onChange={handleChangeAge}
                                        />
                                        <div className="d-flex justify-content-between mb-4">
                                            <TextInput
                                                className="form-control w-lg-auto d-inline"
                                                id="ageFrom"
                                                value={ageFrom}
                                                onChange={setValue}
                                            />
                                            <TextInput
                                                className="form-control w-lg-auto d-inline"
                                                id="ageTo"
                                                value={ageTo}
                                                onChange={setValue}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end mb-4">
                                            <button className="btn btn-primary form-control w-lg-auto d-inline" onClick={addSelectAge}>
                                                선택
                                            </button>
                                        </div>
                                    </div>
                                }
                                {
                                    targetingCategory === "SEX" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                <div className="columnRightItem" onClick={() => handleChangeSex(0)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 0}
                                                        readOnly
                                                    />
                                                    <p className="m-0 ps-2">전체</p>
                                                </div>
                                                <div className="columnRightItem" onClick={() => handleChangeSex(1)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 1}
                                                        readOnly
                                                    />
                                                    <p className="m-0 ps-2">남성</p>
                                                </div>
                                                <div className="columnRightItem" onClick={() => handleChangeSex(2)}>
                                                    <input
                                                        className='form-check-input'
                                                        type="radio"
                                                        checked={sex === 2}
                                                        readOnly
                                                    />
                                                    <p className="m-0 ps-2">여성</p>
                                                </div>
                                            </Grid>
                                            <Grid item xs={4} className="columnRight columnOverFlow"></Grid>
                                            <Grid item xs={4} className="columnOverFlow"></Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "APP" &&
                                    <div className="h-100 col columnOverFlow">
                                        <div className="p-3" style={{ borderBottom: '1px solid #DEDEDE' }}>
                                            <h4 className="mb-1">사용 앱/웹</h4>
                                            <p className="p-0 text-light-gray mb-2" style={{ fontSize: 13 }}>
                                                * 앱/웹 명칭은 한글 또는 영어로 검색해주세요.<br/>
                                                * 검색한 명칭의 앱/웹이 없는 경우 '등록 요청하기' 버튼이 노출됩니다.
                                            </p>
                                            <div className='d-flex'>
                                                <TextInput
                                                    className='form-control-sm me-1 align-items-center'
                                                    type="text"
                                                    id="webappSearch"
                                                    value={webappSearch}
                                                    onChange={handleChangeWebAppSearch}
                                                    onKeyDown={searchWebAppAction}
                                                />
                                                <button
                                                    className='btn btn-primary'
                                                    onClick={ajaxGetWebAppList}
                                                >검색</button>
                                            </div>
                                        </div>
                                        <div className="p-0">
                                            {
                                                webappListTotal > 0 &&
                                                <>
                                                    <div className="row py-2 p-3">
                                                        <div className="col-lg-6">총 {webappListTotal} 건</div>
                                                    </div>
                                                    {
                                                        webappList.map((item, index) => (
                                                            <div
                                                                className="columnRightItem"
                                                                key={index}
                                                                onClick={() => handleCheckWebapp(item)}
                                                            >
                                                                <input
                                                                    className='form-check-input'
                                                                    type="checkbox"
                                                                    checked={arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "APP", "value", item.value)}
                                                                    // onChange={() => handleCheckWebapp(item)}
                                                                    readOnly
                                                                />
                                                                <p className="m-0 ps-2">{item.name}</p>
                                                            </div>
                                                        ))
                                                    }
                                                    <PaginationComponent page={webappListPage} total={webappListTotal} sizePerPage={webappListSize} handleChange={handleWebappListPageChange}/>
                                                </>
                                            }
                                            {
                                                webappSearchResult === false &&
                                                <div className="d-flex flex-column align-items-center">
                                                    <p className="mt-3">검색 결과가 없습니다.</p>
                                                    <SingleButton
                                                        className="btn btn-primary"
                                                        label="+ 등록 요청"
                                                        handleClick={handleWebappRequestModal}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    targetingCategory === "DYNAMIC_PROFILE" &&
                                    <div className="h-100 col columnOverFlow">
                                        <div className="p-3" style={{ borderBottom: '1px solid #DEDEDE' }}>
                                            <h4 className="mb-1">고객 성향</h4>
                                            <p className="p-0 text-light-gray mb-0" style={{ fontSize: 13 }}>
                                                * 관심사·라이프스타일 기반 타겟팅
                                            </p>
                                            <div className='d-flex mt-3'>
                                                <TextInput
                                                    className='form-control-sm me-1 align-items-center'
                                                    type="text"
                                                    id="dynamicProfileSearch"
                                                    value={dynamicProfileSearch}
                                                    onChange={handleChangeDynamicProfileSearch}
                                                    onKeyDown={searchDynamicProfileAction}
                                                />
                                                <button
                                                    className='btn btn-primary'
                                                    onClick={ajaxGetDynamicProfileList}
                                                >검색</button>
                                            </div>
                                        </div>
                                        <div className="p-0">
                                            <div className="row py-2 p-3">
                                                <div className="col-lg-6">총 {dynamicProfileListTotal} 건</div>
                                            </div>
                                            {
                                                dynamicProfileList.map((item, index) => (
                                                    <div
                                                        className="columnRightItem"
                                                        key={index}
                                                        onClick={() => handleCheckDynamicProfile(item)}
                                                    >
                                                            <input
                                                                className='form-check-input'
                                                                type="checkbox"
                                                            checked={arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "DYNAMIC_PROFILE", "label", `고객 성향 : ${item.profileName}`)}
                                                                readOnly
                                                            />
                                                        <div className="ps-2">
                                                            <p className="m-0">{item.profileName}</p>
                                                            {item.description && (
                                                                <p className="m-0 text-light-gray" style={{ fontSize: 12 }}>{item.description}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            <PaginationComponent
                                                page={dynamicProfileListPage}
                                                total={dynamicProfileListTotal}
                                                sizePerPage={dynamicProfileListSize}
                                                handleChange={handleDynamicProfileListPageChange}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    targetingCategory === "POI" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} columns={20}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    poiCat1List.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangePoiCat1(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={poiCat1Value === item.value}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    poiCat2List.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangePoiCat2(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={poiCat2Value === item.value}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    poiCat3List.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangePoiCat3(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={poiCat3Value === item.value}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    poiCat4List.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangePoiCat4(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={poiCat4Value === item.value}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    poiItemList.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangePoiItem(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={poiItemValue === item.value}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "TEL" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    telMain.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeTelMainValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={telMainValue === item.uid}
                                                                // onChange={() => handleChangeTelMainValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    telMid.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeTelMidValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={telMidValue === item.uid}
                                                                // onChange={() => handleChangeTelMidValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    telSub.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeTelSubValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={telSubValue === item.uid}
                                                                // onChange={() => handleChangeTelSubValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "HOMELOC" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    homeMain.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeHomeMainValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={homeMainValue === item.uid}
                                                                // onChange={() => handleChangeHomeMainValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    (homeMainLabel && homeMainValue) &&
                                                    <div className="columnRightItem" onClick={() => handleCheckHomeMidAll()}>
                                                        <input
                                                            className='form-check-input'
                                                            type="radio"
                                                            checked={homeMidCheckAll}
                                                            // onChange={() => handleCheckHomeMidAll()}
                                                            readOnly
                                                        />
                                                        <p className="m-0 ps-2">{homeMainLabel} 전체</p>
                                                    </div>
                                                }
                                                {
                                                    homeMid.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeHomeMidValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={homeMidValue === item.uid}
                                                                // onChange={() => handleChangeHomeMidValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    (homeMidLabel && homeMidValue) &&
                                                    <div className="columnRightItem" onClick={() => handleCheckHomeSubAll()}>
                                                        <input
                                                            className='form-check-input'
                                                            type="radio"
                                                            checked={homeSubCheckAll}
                                                            // onChange={() => handleCheckHomeSubAll()}
                                                            readOnly
                                                        />
                                                        <p className="m-0 ps-2">{homeMidLabel} 전체</p>
                                                    </div>
                                                }
                                                {
                                                    homeSub.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeHomeSubValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={homeSubValue === item.uid}
                                                                // onChange={() => handleChangeHomeSubValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "WORKLOC" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} colums={12}>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    workMain.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeWorkMainValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={workMainValue === item.uid}
                                                                // onChange={() => handleChangeWorkMainValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow columnRight">
                                                {
                                                    (workMainLabel && workMainValue) &&
                                                    <div className="columnRightItem" onClick={() => handleCheckWorkMidAll()}>
                                                        <input
                                                            className='form-check-input'
                                                            type="radio"
                                                            checked={workMidCheckAll}
                                                            // onChange={() => handleCheckWorkMidAll()}
                                                            readOnly
                                                        />
                                                        <p className="m-0 ps-2">{workMainLabel} 전체</p>
                                                    </div>
                                                }
                                                {
                                                    workMid.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeWorkMidValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={workMidValue === item.uid}
                                                                // onChange={() => handleChangeWorkMidValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={4} className="columnOverFlow">
                                                {
                                                    (workMidLabel && workMidValue) &&
                                                    <div className="columnRightItem" onClick={() => handleCheckWorkSubAll()}>
                                                        <input
                                                            className='form-check-input'
                                                            type="radio"
                                                            checked={workSubCheckAll}
                                                            // onChange={() => handleCheckWorkSubAll()}
                                                            readOnly
                                                        />
                                                        <p className="m-0 ps-2">{workMidLabel} 전체</p>
                                                    </div>
                                                }
                                                {
                                                    workSub.map((item, index) =>
                                                        <div key={index} className="columnRightItem" onClick={() => handleChangeWorkSubValue(item)}>
                                                            <input
                                                                className='form-check-input'
                                                                type="radio"
                                                                checked={workSubValue === item.uid}
                                                                // onChange={() => handleChangeWorkSubValue(item)}
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{item.name}</p>
                                                        </div>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "PRO" &&
                                    <div className="h-100 row">
                                        <Grid container spacing={0} columns={12}>
                                            {/* 좌측 - 상위 카테고리 */}
                                            <Grid item xs={4} className="columnOverFlow">
                                                {proMainList.map((main) => {
                                                    const subList = proSubList[main.code];

                                                    // 상위 체크 여부 계산
                                                    const isSubSelected = subList?.some((sub) => sub.code === this.state.pro);
                                                    const isMainChecked = this.state.pro === main.code || isSubSelected;

                                                    return (
                                                        <div
                                                            key={main.code}
                                                            className="columnRightItem"
                                                            onClick={() => {
                                                                if (!subList) {
                                                                    // 하위 없는 항목 → 바로 선택 & 하위 영역 숨김
                                                                    this.handleChangePro(main.code);
                                                                    this.setState({ selectedProMain: null });
                                                                } else {
                                                                    // 하위 있는 항목 → 오른쪽에 표시 & 상위도 선택
                                                                    this.setState({ selectedProMain: main.code, pro: main.code });
                                                                }
                                                            }}
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                checked={Boolean(isMainChecked)} // boolean으로 강제
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{main.label}</p>
                                                        </div>
                                                    );
                                                })}
                                            </Grid>

                                            {/* 우측 - 하위 카테고리 */}
                                            <Grid item xs={8} className="columnOverFlow columnRight">
                                                {this.state.selectedProMain &&
                                                    proSubList[this.state.selectedProMain]?.map((sub) => (
                                                        <div
                                                            key={sub.code}
                                                            className="columnRightItem"
                                                            onClick={() => this.handleChangePro(sub.code)}
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                checked={Boolean(this.state.pro === sub.code)} // boolean으로 강제
                                                                readOnly
                                                            />
                                                            <p className="m-0 ps-2">{sub.label}</p>
                                                        </div>
                                                    ))}
                                            </Grid>

                                            <Grid item xs={4} className="columnOverFlow"></Grid>
                                        </Grid>
                                    </div>
                                }
                                {
                                    targetingCategory === "CALL" &&
                                    <div className="h-100 col columnOverFlow">
                                        <div className="p-3" style={{ borderBottom: '1px solid #DEDEDE' }}>
                                            <h4 className="mb-1">전화번호명</h4>
                                            <p className="p-0 text-light-gray mb-2" style={{ fontSize: 13 }}>* 전화번호는 마이페이지에서 등록할 수 있습니다.</p>
                                            <div className='d-flex mb-3'>
                                                <TextInput
                                                    className='form-control-sm me-1 align-items-center'
                                                    type="text"
                                                    id="phoneSearch"
                                                    value={phoneSearch}
                                                    onChange={handleChangePhoneSearch}
                                                    onKeyDown={searchPhoneNameAction}
                                                />
                                                <SingleButton
                                                    className='btn btn-primary'
                                                    label="검색"
                                                    handleClick={ajaxGetPhoneList}
                                                />
                                            </div>
                                            <SingleButton
                                                className='btn btn-primary btn-sm'
                                                label="전화번호 추가하기"
                                                handleClick={() => handlePhoneRegisterModal('phoneRegisterModal', true)}
                                            />
                                        </div>
                                        <div className="p-0">
                                            <div className="row py-2 p-3">
                                                <div className="col-lg-6">총 {phoneListTotal} 건</div>
                                            </div>
                                            {
                                                phoneList.map((item, index) => (
                                                    <div
                                                        className="columnRightItem"
                                                        key={index}
                                                        onClick={() => handleCheckPhoneNumber(item)}
                                                    >
                                                        <input
                                                            className='form-check-input'
                                                            type="radio"
                                                            checked={arrayUtil.containsJsonElementMultiKey(atsSelectList, "type", "CALL", "value", item.registerName)}
                                                            // onChange={() => handleCheckPhoneNumber(item)}
                                                            readOnly
                                                        />
                                                        <p className="m-0 ps-2">{item.name}</p>
                                                    </div>
                                                ))
                                            }
                                            <PaginationComponent page={phoneListPage} total={phoneListTotal} sizePerPage={phoneListSize} handleChange={handlePhoneListPageChange}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    { !isRemind &&
                    <div className="p-3 d-flex flex-wrap">
                        {
                            atsSelectList.map((item, index) =>
                                <Chip
                                    key={index}
                                    className="m-1"
                                    color="info"
                                    variant="outlined"
                                    onDelete={() => deleteSelectedValue(item)}
                                    sx={chipButtonStyle}
                                    // draggable
                                    // onDragStart={(e) => this.handleDragStart(e, item, "SELECT")}
                                    label={
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span>{item.label}</span>
                                            <IconButton
                                                size="small"
                                                sx={button1Style}
                                                onClick={() => moveToAnd(item)}
                                            >
                                                AND 추가
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                sx={button2Style}
                                                onClick={() =>moveToOr(item)}
                                            >
                                                OR 추가
                                            </IconButton>
                                        </div>
                                    }
                                />
                            )
                        }
                    </div>
                    }
                    <div className="p-3 d-flex flex-wrap ">
                        <div className="p-3 selected-mosu-container">
                            <Grid container spacing={2} columns={12}>
                                <Grid item xs={6}>
                                    <div
                                        className="mosu-and"
                                        // onDragOver={this.allowDrop}
                                        // onDrop={(e) => this.handleDrop(e, "AND")}
                                        style={{ minHeight: "150px" }}
                                    >
                                        <p className="mb-0 fw-bolder">영역 내 조건을 모두 만족하는 고객만 포함</p>
                                        {
                                            atsAndList.map((item, index) =>
                                                <Chip
                                                    key={index}
                                                    className="m-1"
                                                    color="info"
                                                    variant="filled"
                                                    onDelete={!isRemind ? () => deleteAndSelectedValue(item) : undefined}
                                                    sx={chipButtonStyle}
                                                    // draggable
                                                    // onDragStart={(e) => this.handleDragStart(e, item, "AND")}
                                                    label={
                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                            <span>{item.label}</span>
                                                            {!isRemind && (
                                                                <IconButton
                                                                    size="small"
                                                                    sx={button2Style}
                                                                    onClick={() => moveFromAndToOr(item)}
                                                                >
                                                                    OR 이동
                                                                </IconButton>
                                                            )}
                                                        </div>
                                                    }
                                                />
                                            )
                                        }
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                     <div
                                        className="mosu-or"
                                        // onDragOver={this.allowDrop}
                                        // onDrop={(e) => this.handleDrop(e, "OR")}
                                        style={{ minHeight: "150px" }}
                                     >
                                         <p className="mb-0 fw-bolder">영역 내 조건 중 1개 이상 해당</p>
                                         {
                                             atsOrList.map((item, index) =>
                                                 <Chip
                                                     key={index}
                                                     className="m-1"
                                                     color="info"
                                                     variant="filled"
                                                     onDelete={!isRemind ? () => deleteOrSelectedValue(item) : undefined}
                                                     sx={chipButtonStyle}
                                                     // draggable
                                                     // onDragStart={(e) => this.handleDragStart(e, item, "OR")}
                                                     label={
                                                         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                             <span>{item.label}</span>
                                                             {!isRemind && (
                                                                 <IconButton
                                                                     size="small"
                                                                     sx={button1Style}
                                                                     onClick={() => moveFromOrToAnd(item)}
                                                                 >
                                                                     AND 이동
                                                                 </IconButton>
                                                             )}
                                                         </div>
                                                     }
                                                 />
                                             )
                                         }
                                     </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className='p-6 mt-3'>
                            { targetLabel && targetLabel.length > 0 &&
                                <p style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                    타겟 확인 : {targetLabel}
                                </p>
                            }
                        </div>
                    </div>
                </div>
                <div className='modal-footer'>
                    { !isRemind &&
                        <button className='btn btn-danger btn-md me-2' onClick={resetTargeting}>선택 초기화</button>
                    }
                    <button className='btn btn-primary btn-md' onClick={ajaxGetMosu}>모수확인</button>
                </div>
            </Modal>
            <AppRequestModal
                isOpen={appRequestModal}
                handleClose={handleWebappRequestModal}
            />
                <PhoneRegisterModal
                    isOpen={phoneRegisterModal}
                    handleClose={handlePhoneRegisterModal}
                    onRequestClose={() => handlePhoneRegisterModal('phoneRegisterModal', false)}
                    setValue={setPhoneRegisterInfo}
                    phoneName={phoneRegisterName}
                    phoneList={phoneRegisterList}
                    registerAction={ajaxRegisterPhoneNumber}
                />
            </>
        )
    }
}

MessageMosuSelectModal.defaultProps = {
    isOpen: false,
    handleClose: function() {},
    setMosuData: function() {},
    resetMosuData: function() {},
}

export default MessageMosuSelectModal;
